import React from 'react';
import {FormattedMessage} from "react-intl";

import './PrivacyPolicyView.style.scss';
const PrivacyPolicyView = () => {

    window.scrollTo(0, 0);

    return (
        <div className={'PrivacyPolicyView'}>
            <h1><FormattedMessage id={'privacyPolicy.title'}/></h1>
            <p><FormattedMessage id={'privacyPolicy.lastUpdated'}/></p>
            <p><FormattedMessage id={'privacyPolicy.content.p1'}/></p>
            <p><FormattedMessage id={'privacyPolicy.content.p2'}/></p>
            <p><FormattedMessage id={'privacyPolicy.content.p3'}/></p>
            <p className={'q1'}><FormattedMessage id={'privacyPolicy.content.q1'}/></p>
            <p className={'q1a1'}><FormattedMessage id={'privacyPolicy.content.q1a1'}/></p>
            <p><FormattedMessage id={'privacyPolicy.content.q1a2'}/></p>
            <p className={'q2'}><FormattedMessage id={'privacyPolicy.content.q2'}/></p>
            <p className={'q2a1'}><FormattedMessage id={'privacyPolicy.content.q2a1'}/></p>
            <p className={'q3'}><FormattedMessage id={'privacyPolicy.content.q3'}/></p>
            <p className={'q3a1'}><FormattedMessage id={'privacyPolicy.content.q3a1'}/></p>
        </div>
    );
}

export default PrivacyPolicyView;